import { N as push, S as getContext, Y as spread_props, X as bind_props, P as pop, V as spread_attributes, O as setContext, a0 as store_get, a3 as unsubscribe_stores, $ as ensure_array_like, W as clsx, a1 as attr, Z as copy_payload, _ as assign_payload, T as escape_html } from "../../../../chunks/index.js";
import { L as Logo } from "../../../../chunks/Logo.js";
import { c as classMap, a as SmuiElement, R as Ripple, d as dispatch, M as Menu, L as List, I as Item } from "../../../../chunks/Menu.js";
import "clsx";
import { C as ClassAdder, I as IconButton, T as Text, G as Graphic } from "../../../../chunks/Graphic.js";
import { S as Separator } from "../../../../chunks/Separator.js";
import { g as goto } from "../../../../chunks/client.js";
import dayjs from "dayjs";
import { e as exclude, p as prefixFilter } from "../../../../chunks/prefixFilter.js";
import { w as writable } from "../../../../chunks/exports.js";
import { o as onDestroy } from "../../../../chunks/index-server.js";
function CommonLabel($$payload, $$props) {
  push();
  let {
    use = [],
    class: className = "",
    component: MyComponent = SmuiElement,
    tag = "span",
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  const context = getContext("SMUI:label:context");
  const tabindex = getContext("SMUI:label:tabindex");
  function getElement() {
    return element.getElement();
  }
  $$payload.out += `<!---->`;
  MyComponent($$payload, spread_props([
    {
      tag,
      use,
      class: classMap({
        [className]: true,
        "mdc-button__label": context === "button",
        "mdc-fab__label": context === "fab",
        "mdc-tab__text-label": context === "tab",
        "mdc-image-list__label": context === "image-list",
        "mdc-snackbar__label": context === "snackbar",
        "mdc-banner__text": context === "banner",
        "mdc-segmented-button__label": context === "segmented-button",
        "mdc-data-table__pagination-rows-per-page-label": context === "data-table:pagination",
        "mdc-data-table__header-cell-label": context === "data-table:sortable-header-cell"
      })
    },
    context === "snackbar" ? { "aria-atomic": "false" } : {},
    { tabindex },
    restProps,
    {
      children: ($$payload2) => {
        children?.($$payload2);
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  $$payload.out += `<!---->`;
  bind_props($$props, { getElement });
  pop();
}
function CommonIcon($$payload, $$props) {
  push();
  let {
    use = [],
    class: className = "",
    on = false,
    component: MyComponent = SmuiElement,
    tag = "i",
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  const svg = tag === "svg" || MyComponent === Svg;
  const context = getContext("SMUI:icon:context");
  function getElement() {
    return element.getElement();
  }
  $$payload.out += `<!---->`;
  MyComponent($$payload, spread_props([
    {
      tag,
      use,
      class: classMap({
        [className]: true,
        "mdc-button__icon": context === "button",
        "mdc-fab__icon": context === "fab",
        "mdc-icon-button__icon": context === "icon-button",
        "mdc-icon-button__icon--on": context === "icon-button" && on,
        "mdc-tab__icon": context === "tab",
        "mdc-banner__icon": context === "banner",
        "mdc-segmented-button__icon": context === "segmented-button"
      }),
      "aria-hidden": "true"
    },
    svg ? { focusable: "false", tabindex: "-1" } : {},
    restProps,
    {
      children: ($$payload2) => {
        children?.($$payload2);
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  $$payload.out += `<!---->`;
  bind_props($$props, { getElement });
  pop();
}
function Svg($$payload, $$props) {
  push();
  if (console && console.warn) {
    console.warn('The @smui/common Svg component is deprecated. You can use `tag="svg"` now.');
  }
  let {
    use = [],
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  function getElement() {
    return element;
  }
  $$payload.out += `<svg${spread_attributes({ ...restProps }, void 0, void 0, 3)}>`;
  children?.($$payload);
  $$payload.out += `<!----></svg>`;
  bind_props($$props, { getElement });
  pop();
}
function ContextFragment($$payload, $$props) {
  push();
  let { key, value, children } = $$props;
  const storeValue = writable(value);
  setContext(key, storeValue);
  onDestroy(() => {
    storeValue.set(void 0);
  });
  children?.($$payload);
  $$payload.out += `<!---->`;
  pop();
}
function PrimaryText($$payload, $$props) {
  push();
  let { children, $$slots, $$events, ...restProps } = $$props;
  let element;
  function getElement() {
    return element.getElement();
  }
  ClassAdder($$payload, spread_props([
    {
      _smuiClass: "mdc-deprecated-list-item__primary-text",
      tag: "span"
    },
    restProps,
    {
      children: ($$payload2) => {
        children?.($$payload2);
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  bind_props($$props, { getElement });
  pop();
}
function SecondaryText($$payload, $$props) {
  push();
  let { children, $$slots, $$events, ...restProps } = $$props;
  let element;
  function getElement() {
    return element.getElement();
  }
  ClassAdder($$payload, spread_props([
    {
      _smuiClass: "mdc-deprecated-list-item__secondary-text",
      tag: "span"
    },
    restProps,
    {
      children: ($$payload2) => {
        children?.($$payload2);
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  bind_props($$props, { getElement });
  pop();
}
function Chip($$payload, $$props) {
  push();
  var $$store_subs;
  let {
    use = [],
    class: className = "",
    style = "",
    chip: chipId,
    ripple = true,
    touch = false,
    shouldRemoveOnTrailingIconClick = true,
    shouldFocusPrimaryActionOnClick = true,
    component: MyComponent = SmuiElement,
    tag = "div",
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  let internalClasses = {};
  let leadingIconClasses = {};
  let internalStyles = {};
  const initialSelectedStore = getContext("SMUI:chips:chip:initialSelected");
  let selected = store_get($$store_subs ??= {}, "$initialSelectedStore", initialSelectedStore);
  const nonInteractive = getContext("SMUI:chips:nonInteractive");
  const choice = getContext("SMUI:chips:choice");
  const index = getContext("SMUI:chips:chip:index");
  const shouldRemoveOnTrailingIconClickStore = writable(shouldRemoveOnTrailingIconClick);
  setContext("SMUI:chips:chip:shouldRemoveOnTrailingIconClick", shouldRemoveOnTrailingIconClickStore);
  const isSelectedStore = writable(selected);
  setContext("SMUI:chips:chip:isSelected", isSelectedStore);
  const leadingIconClassesStore = writable(leadingIconClasses);
  setContext("SMUI:chips:chip:leadingIconClasses", leadingIconClassesStore);
  setContext("SMUI:chips:chip:focusable", store_get($$store_subs ??= {}, "$choice", choice) && selected || store_get($$store_subs ??= {}, "$index", index) === 0);
  setContext("SMUI:chips:primary-action:mount", (accessor) => {
  });
  setContext("SMUI:chips:primary-action:unmount", () => {
  });
  setContext("SMUI:chips:trailing-action:mount", (accessor) => {
  });
  setContext("SMUI:chips:trailing-action:unmount", () => {
  });
  getContext("SMUI:chips:chip:mount");
  getContext("SMUI:chips:chip:unmount");
  function addClass(className2) {
    if (!internalClasses[className2]) {
      internalClasses[className2] = true;
    }
  }
  function removeClass(className2) {
    if (!(className2 in internalClasses) || internalClasses[className2]) {
      internalClasses[className2] = false;
    }
  }
  function addStyle(name, value) {
    if (internalStyles[name] != value) {
      if (value === "" || value == null) {
        delete internalStyles[name];
      } else {
        internalStyles[name] = value;
      }
    }
  }
  function getElement() {
    return element.getElement();
  }
  $$payload.out += `<!---->`;
  MyComponent($$payload, spread_props([
    {
      tag,
      use: [
        [
          Ripple,
          {
            ripple: ripple && !store_get($$store_subs ??= {}, "$nonInteractive", nonInteractive),
            unbounded: false,
            addClass,
            removeClass,
            addStyle
          }
        ],
        ...use
      ],
      class: classMap({
        [className]: true,
        "mdc-chip": true,
        "mdc-chip--selected": selected,
        "mdc-chip--touch": touch,
        ...internalClasses
      }),
      style: Object.entries(internalStyles).map(([name, value]) => `${name}: ${value};`).concat([style]).join(" "),
      role: "row"
    },
    restProps,
    {
      ontransitionend: (e) => {
        restProps.ontransitionend?.(e);
      },
      onclick: (e) => {
        restProps.onclick?.(e);
      },
      onkeydown: (e) => {
        restProps.onkeydown?.(e);
      },
      onfocusin: (e) => {
        restProps.onfocusin?.(e);
      },
      onfocusout: (e) => {
        restProps.onfocusout?.(e);
      },
      onSMUIChipTrailingActionInteraction: (e) => {
        restProps.onSMUIChipTrailingActionInteraction?.(e);
      },
      onSMUIChipTrailingActionNavigation: (e) => {
        restProps.onSMUIChipTrailingActionNavigation?.(e);
      },
      children: ($$payload2) => {
        if (ripple && !store_get($$store_subs ??= {}, "$nonInteractive", nonInteractive)) {
          $$payload2.out += "<!--[-->";
          $$payload2.out += `<div class="mdc-chip__ripple"></div>`;
        } else {
          $$payload2.out += "<!--[!-->";
        }
        $$payload2.out += `<!--]--> `;
        children?.($$payload2);
        $$payload2.out += `<!----> `;
        if (touch) {
          $$payload2.out += "<!--[-->";
          $$payload2.out += `<div class="mdc-chip__touch"></div>`;
        } else {
          $$payload2.out += "<!--[!-->";
        }
        $$payload2.out += `<!--]-->`;
      },
      $$slots: { default: true }
    }
  ]));
  $$payload.out += `<!---->`;
  if ($$store_subs) unsubscribe_stores($$store_subs);
  bind_props($$props, { getElement });
  pop();
}
function Set_1($$payload, $$props) {
  push();
  let {
    use = [],
    class: className = "",
    chips = [],
    key = (chip2) => `${chip2}`,
    selected = void 0,
    nonInteractive = false,
    choice = false,
    filter = false,
    input = false,
    chip,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  if (filter && choice) {
    throw new Error("Chip sets can be either filter or choice, but not both.");
  }
  if (choice && typeof selected === "object" && "findIndex" in selected) {
    throw new Error("Choice chips must not be given multiple selected chips.");
  }
  if (filter && selected !== void 0 && (typeof selected !== "object" || !("findIndex" in selected))) {
    throw new Error("Filter chips must be given an array of selected chips.");
  }
  let element;
  let chipAccessorWeakMap = /* @__PURE__ */ new WeakMap();
  let initialSelected = chips.map((chipId) => choice && selected != null && key(selected) === key(chipId) || filter && selected != null && selected.findIndex((chip2) => key(chip2) === key(chipId)) !== -1);
  setContext("SMUI:chips:key", key);
  const nonInteractiveStore = writable(nonInteractive);
  setContext("SMUI:chips:nonInteractive", nonInteractiveStore);
  const choiceStore = writable(choice);
  setContext("SMUI:chips:choice", choiceStore);
  const filterStore = writable(filter);
  setContext("SMUI:chips:filter", filterStore);
  filter ? new Set(selected ?? []) : selected;
  setContext("SMUI:chips:chip:mount", (accessor) => {
    addAccessor(accessor.chipId, accessor);
  });
  setContext("SMUI:chips:chip:unmount", (accessor) => {
    removeAccessor(accessor.chipId);
  });
  function addAccessor(chipId, accessor) {
    if (chipId instanceof Object) {
      chipAccessorWeakMap.set(chipId, accessor);
    }
  }
  function removeAccessor(chipId) {
    if (chipId instanceof Object) {
      chipAccessorWeakMap.delete(chipId);
    }
  }
  function getElement() {
    return element;
  }
  const each_array = ensure_array_like(chips);
  $$payload.out += `<div${spread_attributes({
    class: clsx(classMap({
      [className]: true,
      "mdc-chip-set": true,
      "smui-chip-set--non-interactive": nonInteractive,
      "mdc-chip-set--choice": choice,
      "mdc-chip-set--filter": filter,
      "mdc-chip-set--input": input
    })),
    role: "grid",
    ...restProps
  })}><!--[-->`;
  for (let i = 0, $$length = each_array.length; i < $$length; i++) {
    let chipKey = each_array[i];
    ContextFragment($$payload, {
      key: "SMUI:chips:chip:index",
      value: i,
      children: ($$payload2) => {
        ContextFragment($$payload2, {
          key: "SMUI:chips:chip:initialSelected",
          value: initialSelected[i],
          children: ($$payload3) => {
            chip($$payload3, chipKey);
            $$payload3.out += `<!---->`;
          },
          $$slots: { default: true }
        });
      },
      $$slots: { default: true }
    });
  }
  $$payload.out += `<!--]--></div>`;
  bind_props($$props, { chips, selected, getElement });
  pop();
}
function TrailingAction($$payload, $$props) {
  push();
  let {
    use = [],
    class: className = "",
    style = "",
    ripple = true,
    touch = false,
    nonNavigable = false,
    icon$use = [],
    icon$class = "",
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  let internalClasses = {};
  let internalStyles = {};
  let internalAttrs = {};
  getContext("SMUI:chips:trailing-action:mount");
  getContext("SMUI:chips:trailing-action:unmount");
  function isNavigable() {
    {
      throw new Error("Instance is undefined.");
    }
  }
  function focus() {
  }
  function removeFocus() {
  }
  function getElement() {
    return element;
  }
  $$payload.out += `<button${spread_attributes({
    type: "button",
    class: clsx(classMap({
      [className]: true,
      "mdc-deprecated-chip-trailing-action": true,
      ...internalClasses
    })),
    style: Object.entries(internalStyles).map(([name, value]) => `${name}: ${value};`).concat([style]).join(" "),
    "aria-hidden": nonNavigable ? "true" : void 0,
    tabindex: "-1",
    ...internalAttrs,
    ...exclude(restProps, ["icon$"])
  })}><span class="mdc-deprecated-chip-trailing-action__ripple"></span> `;
  if (touch) {
    $$payload.out += "<!--[-->";
    $$payload.out += `<span class="mdc-deprecated-chip-trailing-action__touch"></span>`;
  } else {
    $$payload.out += "<!--[!-->";
  }
  $$payload.out += `<!--]--> <span${spread_attributes({
    class: clsx(classMap({
      [icon$class]: true,
      "mdc-deprecated-chip-trailing-action__icon": true
    })),
    ...prefixFilter(restProps, "icon$")
  })}>`;
  children?.($$payload);
  $$payload.out += `<!----></span></button>`;
  bind_props($$props, { isNavigable, focus, removeFocus, getElement });
  pop();
}
function Button($$payload, $$props) {
  push();
  let {
    use = [],
    class: className = "",
    style = "",
    ripple = true,
    color = "primary",
    variant = "text",
    touch = false,
    href,
    action = "close",
    defaultAction = false,
    secondary = false,
    component: MyComponent = SmuiElement,
    tag = href == null ? "button" : "a",
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  let internalClasses = {};
  let internalStyles = {};
  let context = getContext("SMUI:button:context");
  const actionProp = context === "dialog:action" && action != null ? { "data-mdc-dialog-action": action } : { action };
  const defaultProp = context === "dialog:action" && defaultAction ? { "data-mdc-dialog-button-default": "" } : {};
  const secondaryProp = context === "banner" ? {} : { secondary };
  restProps.disabled;
  setContext("SMUI:label:context", "button");
  setContext("SMUI:icon:context", "button");
  function addClass(className2) {
    if (!internalClasses[className2]) {
      internalClasses[className2] = true;
    }
  }
  function removeClass(className2) {
    if (!(className2 in internalClasses) || internalClasses[className2]) {
      internalClasses[className2] = false;
    }
  }
  function addStyle(name, value) {
    if (internalStyles[name] != value) {
      if (value === "" || value == null) {
        delete internalStyles[name];
      } else {
        internalStyles[name] = value;
      }
    }
  }
  function handleClick() {
    if (context === "banner") {
      dispatch(getElement(), secondary ? "SMUIBannerButtonSecondaryActionClick" : "SMUIBannerButtonPrimaryActionClick");
    }
  }
  function getElement() {
    return element.getElement();
  }
  $$payload.out += `<!---->`;
  MyComponent($$payload, spread_props([
    {
      tag,
      use: [
        [
          Ripple,
          {
            ripple,
            unbounded: false,
            color,
            disabled: !!restProps.disabled,
            addClass,
            removeClass,
            addStyle
          }
        ],
        ...use
      ],
      class: classMap({
        [className]: true,
        "mdc-button": true,
        "mdc-button--raised": variant === "raised",
        "mdc-button--unelevated": variant === "unelevated",
        "mdc-button--outlined": variant === "outlined",
        "smui-button--color-secondary": color === "secondary",
        "mdc-button--touch": touch,
        "mdc-card__action": context === "card:action",
        "mdc-card__action--button": context === "card:action",
        "mdc-dialog__button": context === "dialog:action",
        "mdc-top-app-bar__navigation-icon": context === "top-app-bar:navigation",
        "mdc-top-app-bar__action-item": context === "top-app-bar:action",
        "mdc-snackbar__action": context === "snackbar:actions",
        "mdc-banner__secondary-action": context === "banner" && secondary,
        "mdc-banner__primary-action": context === "banner" && !secondary,
        "mdc-tooltip__action": context === "tooltip:rich-actions",
        ...internalClasses
      }),
      style: Object.entries(internalStyles).map(([name, value]) => `${name}: ${value};`).concat([style]).join(" ")
    },
    actionProp,
    defaultProp,
    secondaryProp,
    { href },
    restProps,
    {
      onclick: (e) => {
        handleClick();
        restProps.onclick?.(e);
      },
      children: ($$payload2) => {
        $$payload2.out += `<div class="mdc-button__ripple"></div> `;
        children?.($$payload2);
        $$payload2.out += `<!---->`;
        if (touch) {
          $$payload2.out += "<!--[-->";
          $$payload2.out += `<div class="mdc-button__touch"></div>`;
        } else {
          $$payload2.out += "<!--[!-->";
        }
        $$payload2.out += `<!--]-->`;
      },
      $$slots: { default: true }
    }
  ]));
  $$payload.out += `<!---->`;
  bind_props($$props, { getElement });
  pop();
}
function CircularProgress($$payload, $$props) {
  push();
  let {
    use = [],
    class: className = "",
    indeterminate = false,
    closed = false,
    progress = 0,
    fourColor = false,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  let internalClasses = {};
  let internalAttrs = {};
  let determinateCircleAttrs = {};
  function getElement() {
    return element;
  }
  const each_array = ensure_array_like(fourColor ? [1, 2, 3, 4] : [1]);
  $$payload.out += `<div${spread_attributes({
    class: clsx(classMap({
      [className]: true,
      "mdc-circular-progress": true,
      "mdc-circular-progress--indeterminate": indeterminate,
      "mdc-circular-progress--closed": closed,
      ...internalClasses
    })),
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 1,
    "aria-valuenow": indeterminate ? void 0 : progress,
    ...internalAttrs,
    ...restProps
  })}><div class="mdc-circular-progress__determinate-container"><svg class="mdc-circular-progress__determinate-circle-graphic" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><circle class="mdc-circular-progress__determinate-track" cx="24" cy="24" r="18" stroke-width="4"></circle><circle${spread_attributes(
    {
      class: "mdc-circular-progress__determinate-circle",
      cx: "24",
      cy: "24",
      r: "18",
      "stroke-dasharray": "113.097",
      "stroke-dashoffset": "113.097",
      "stroke-width": "4",
      ...determinateCircleAttrs
    },
    void 0,
    void 0,
    3
  )}></circle></svg></div> <div class="mdc-circular-progress__indeterminate-container"><!--[-->`;
  for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
    let color = each_array[$$index];
    $$payload.out += `<div${attr("class", clsx(classMap({
      [className]: true,
      "mdc-circular-progress__spinner-layer": true,
      ["mdc-circular-progress__color-" + color]: fourColor
    })))}><div class="mdc-circular-progress__circle-clipper mdc-circular-progress__circle-left"><svg class="mdc-circular-progress__indeterminate-circle-graphic" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="18" stroke-dasharray="113.097" stroke-dashoffset="56.549" stroke-width="4"></circle></svg></div> <div class="mdc-circular-progress__gap-patch"><svg class="mdc-circular-progress__indeterminate-circle-graphic" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="18" stroke-dasharray="113.097" stroke-dashoffset="56.549" stroke-width="3.2"></circle></svg></div> <div class="mdc-circular-progress__circle-clipper mdc-circular-progress__circle-right"><svg class="mdc-circular-progress__indeterminate-circle-graphic" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="18" stroke-dasharray="113.097" stroke-dashoffset="56.549" stroke-width="4"></circle></svg></div></div>`;
  }
  $$payload.out += `<!--]--></div></div>`;
  bind_props($$props, { getElement });
  pop();
}
let waiting = Promise.resolve();
function Snackbar($$payload, $$props) {
  push();
  let uninitializedValue = () => {
  };
  let {
    use = [],
    class: className = "",
    variant,
    leading = false,
    timeoutMs = 5e3,
    closeOnEscape = true,
    labelText = uninitializedValue,
    actionButtonText = uninitializedValue,
    surface$use = [],
    surface$class = "",
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  let instance = void 0;
  let internalClasses = {};
  let closePromise = new Promise((resolve) => resolve);
  setContext("SMUI:label:context", "snackbar");
  function open() {
    waiting = waiting.then(() => {
      return closePromise;
    });
  }
  function forceOpen() {
    return instance?.open();
  }
  function close(reason) {
    return instance?.close(reason);
  }
  function isOpen() {
    {
      throw new Error("Instance is undefined.");
    }
  }
  function getLabelElement() {
    return getElement().querySelector(".mdc-snackbar__label") ?? document.createElement("div");
  }
  function getActionButtonElement() {
    return getElement().querySelector(".mdc-snackbar__action") ?? document.createElement("button");
  }
  function getElement() {
    return element;
  }
  $$payload.out += `<aside${spread_attributes({
    class: clsx(classMap({
      [className]: true,
      "mdc-snackbar": true,
      "mdc-snackbar--stacked": variant === "stacked",
      "mdc-snackbar--leading": leading,
      ...internalClasses
    })),
    ...exclude(restProps, ["surface$"])
  })}><div${spread_attributes({
    class: clsx(classMap({
      [surface$class]: true,
      "mdc-snackbar__surface": true
    })),
    role: "status",
    "aria-relevant": "additions",
    ...prefixFilter(restProps, "surface$")
  })}>`;
  children?.($$payload);
  $$payload.out += `<!----></div></aside>`;
  bind_props($$props, {
    open,
    forceOpen,
    close,
    isOpen,
    getLabelElement,
    getActionButtonElement,
    getElement
  });
  pop();
}
function Dialog($$payload, $$props) {
  push();
  var $$store_subs;
  let {
    use = [],
    class: className = "",
    open = false,
    selection = false,
    escapeKeyAction = "close",
    scrimClickAction = "close",
    autoStackButtons = true,
    fullscreen = false,
    sheet = false,
    noContentPadding = false,
    container$class = "",
    surface$class = "",
    children,
    over,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  let instance = void 0;
  let internalClasses = {};
  let actionButtonsReversed = writable(false);
  let aboveFullscreen = getContext("SMUI:dialog:aboveFullscreen");
  let aboveFullscreenShown = getContext("SMUI:dialog:aboveFullscreenShown") ?? writable(false);
  let addLayoutListener = getContext("SMUI:addLayoutListener");
  let removeLayoutListener;
  let addLayoutListenerFn = (listener) => {
    return () => {
    };
  };
  setContext("SMUI:dialog:actions:reversed", actionButtonsReversed);
  setContext("SMUI:addLayoutListener", addLayoutListenerFn);
  setContext("SMUI:dialog:selection", selection);
  setContext("SMUI:dialog:aboveFullscreen", aboveFullscreen || fullscreen);
  setContext("SMUI:dialog:aboveFullscreenShown", aboveFullscreenShown);
  if (sheet) {
    setContext("SMUI:icon-button:context", "dialog:sheet");
  }
  if (addLayoutListener) {
    removeLayoutListener = addLayoutListener(layout);
  }
  store_get($$store_subs ??= {}, "$aboveFullscreenShown", aboveFullscreenShown);
  onDestroy(() => {
    if (removeLayoutListener) {
      removeLayoutListener();
    }
  });
  function isOpen() {
    return open;
  }
  function setOpen(value) {
    open = value;
  }
  function layout() {
    return instance?.layout();
  }
  function getElement() {
    return element;
  }
  $$payload.out += `<div${spread_attributes({
    class: clsx(classMap({
      [className]: true,
      "mdc-dialog": true,
      "mdc-dialog--stacked": !autoStackButtons,
      "mdc-dialog--fullscreen": fullscreen,
      "mdc-dialog--sheet": sheet,
      "mdc-dialog--no-content-padding": noContentPadding,
      "smui-dialog--selection": selection,
      ...internalClasses
    })),
    role: "alertdialog",
    "aria-modal": "true",
    ...exclude(restProps, ["container$", "surface$"])
  })}><div${spread_attributes({
    class: clsx(classMap({
      [container$class]: true,
      "mdc-dialog__container": true
    })),
    ...prefixFilter(restProps, "container$")
  })}><div${spread_attributes({
    class: clsx(classMap({
      [surface$class]: true,
      "mdc-dialog__surface": true
    })),
    role: "alertdialog",
    "aria-modal": "true",
    ...prefixFilter(restProps, "surface$")
  })}>`;
  children?.($$payload);
  $$payload.out += `<!----> `;
  if (fullscreen) {
    $$payload.out += "<!--[-->";
    $$payload.out += `<div class="mdc-dialog__surface-scrim"></div>`;
  } else {
    $$payload.out += "<!--[!-->";
  }
  $$payload.out += `<!--]--></div></div> <div class="mdc-dialog__scrim"></div></div> `;
  over?.($$payload);
  $$payload.out += `<!---->`;
  if ($$store_subs) unsubscribe_stores($$store_subs);
  bind_props($$props, { open, isOpen, setOpen, layout, getElement });
  pop();
}
function Title($$payload, $$props) {
  push();
  let { children, $$slots, $$events, ...restProps } = $$props;
  let element;
  function getElement() {
    return element.getElement();
  }
  ClassAdder($$payload, spread_props([
    { _smuiClass: "mdc-dialog__title", tag: "h2" },
    restProps,
    {
      children: ($$payload2) => {
        children?.($$payload2);
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  bind_props($$props, { getElement });
  pop();
}
function Content($$payload, $$props) {
  push();
  let { children, $$slots, $$events, ...restProps } = $$props;
  let element;
  function getElement() {
    return element.getElement();
  }
  ClassAdder($$payload, spread_props([
    { _smuiClass: "mdc-dialog__content", tag: "div" },
    restProps,
    {
      children: ($$payload2) => {
        children?.($$payload2);
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  bind_props($$props, { getElement });
  pop();
}
function Actions($$payload, $$props) {
  push();
  let { children, $$slots, $$events, ...restProps } = $$props;
  let element;
  function getElement() {
    return element.getElement();
  }
  ClassAdder($$payload, spread_props([
    {
      _smuiClass: "mdc-dialog__actions",
      _smuiClassMap: {
        "smui-dialog__actions--reversed": "SMUI:dialog:actions:reversed"
      },
      _smuiContexts: { "SMUI:button:context": "dialog:action" },
      tag: "div"
    },
    restProps,
    {
      children: ($$payload2) => {
        children?.($$payload2);
        $$payload2.out += `<!---->`;
      },
      $$slots: { default: true }
    }
  ]));
  bind_props($$props, { getElement });
  pop();
}
function _page($$payload, $$props) {
  push();
  let { data } = $$props;
  let menu = void 0;
  let anchor = void 0;
  let anchorClasses = {};
  let message = "";
  let installer = data.installer;
  let devices = data.devices;
  let licenseKeyVisible = false;
  const openMenu = () => menu?.setOpen(true);
  const toggleLicenseKeyVisibility = () => licenseKeyVisible = !licenseKeyVisible;
  const copyLicenseKeyToClipboard = () => {
    if (data.license?.code) {
      navigator.clipboard.writeText(data.license.code).then(() => {
        console.log("License key copied to clipboard");
        message = "License key copied to clipboard";
      }).catch((err) => {
        message = "Failed to copy license key to clipboard";
      });
    }
  };
  const handleLogout = async () => {
    await fetch("/api/portal/auth/logout");
    await goto();
  };
  const generateInstaller = async () => {
    const response = await fetch("/api/portal/installer/generate");
    const { data: data2 } = await response.json();
    message = "This should take about 10 minutes or less. Feel free to come back later.";
    installer = data2;
  };
  const downloadInstaller = async () => {
    goto();
  };
  let deviceAddDialogOpen = false;
  let newDeviceId = "";
  const deviceAddDialogCloseHandler = async (e) => {
    switch (e.detail.action) {
      case "confirm":
        const response = await fetch("/api/portal/devices", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: newDeviceId })
        });
        if (response.ok) {
          goto("/portal", { replaceState: true, invalidateAll: true });
        } else {
          message = "Failed to add device";
        }
        break;
      case "cancel":
        deviceAddDialogOpen = false;
        break;
    }
  };
  const openAddDeviceDialog = () => {
    deviceAddDialogOpen = true;
  };
  function navbar($$payload2) {
    $$payload2.out += `<div class="flex items-center justify-between">`;
    Logo($$payload2);
    $$payload2.out += `<!----> <div${attr("class", clsx(Object.keys(anchorClasses).join(" ")))}>`;
    IconButton($$payload2, {
      onclick: openMenu,
      children: ($$payload3) => {
        CommonLabel($$payload3, {
          class: "text-[1rem] font-bold opacity-70",
          children: ($$payload4) => {
            $$payload4.out += `<!---->${escape_html(data.user.email.substring(0, 2).toUpperCase())}`;
          },
          $$slots: { default: true }
        });
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----> `;
    Menu($$payload2, {
      anchor: false,
      anchorElement: anchor,
      anchorCorner: "BOTTOM_LEFT",
      class: "mt-2",
      children: ($$payload3) => {
        List($$payload3, {
          children: ($$payload4) => {
            Item($$payload4, {
              class: "pointer-events-none",
              children: ($$payload5) => {
                Text($$payload5, {
                  children: ($$payload6) => {
                    PrimaryText($$payload6, {
                      children: ($$payload7) => {
                        $$payload7.out += `<!---->${escape_html(data.user.email)}`;
                      },
                      $$slots: { default: true }
                    });
                    $$payload6.out += `<!----> `;
                    SecondaryText($$payload6, {
                      class: "uppercase",
                      children: ($$payload7) => {
                        $$payload7.out += `<!---->${escape_html(data.user.license)}`;
                      },
                      $$slots: { default: true }
                    });
                    $$payload6.out += `<!---->`;
                  },
                  $$slots: { default: true }
                });
              },
              $$slots: { default: true }
            });
            $$payload4.out += `<!----> `;
            Separator($$payload4, {});
            $$payload4.out += `<!----> `;
            Item($$payload4, {
              onSMUIAction: handleLogout,
              children: ($$payload5) => {
                Graphic($$payload5, {
                  class: "material-symbols-outlined",
                  children: ($$payload6) => {
                    $$payload6.out += `<!---->logout`;
                  },
                  $$slots: { default: true }
                });
                $$payload5.out += `<!----> `;
                Text($$payload5, {
                  children: ($$payload6) => {
                    $$payload6.out += `<!---->Sign out`;
                  },
                  $$slots: { default: true }
                });
                $$payload5.out += `<!---->`;
              },
              $$slots: { default: true }
            });
            $$payload4.out += `<!---->`;
          },
          $$slots: { default: true }
        });
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----></div></div>`;
  }
  function renderGenerateButton($$payload2) {
    Button($$payload2, {
      color: "primary",
      onclick: generateInstaller,
      class: "gap-2",
      children: ($$payload3) => {
        CommonIcon($$payload3, {
          class: "material-symbols-outlined",
          children: ($$payload4) => {
            $$payload4.out += `<!---->rocket`;
          },
          $$slots: { default: true }
        });
        $$payload3.out += `<!----> `;
        CommonLabel($$payload3, {
          children: ($$payload4) => {
            $$payload4.out += `<!---->Generate installer`;
          },
          $$slots: { default: true }
        });
        $$payload3.out += `<!---->`;
      },
      $$slots: { default: true }
    });
  }
  function license($$payload2) {
    $$payload2.out += `<div class="bg-white rounded-lg border shadow-md p-6 flex flex-col gap-4"><div class="flex flex-col items-start justify-between gap-4 md:flex-row md:items-center flex-wrap"><div class="flex items-center gap-6"><div class="w-10 h-10 rounded-full bg-teal-50 text-teal-600 flex items-center justify-center"><i class="material-symbols-outlined opacity-70">key</i></div> <div><div class="text-2xl font-display">Your License</div> <div class="opacity-70">Issued on ${escape_html(dayjs(data.license?.issuedOn).format("MM/DD/YYYY"))}</div></div></div> <div class="bg-white border rounded-lg flex items-center gap-4 px-4 py-2 w-full lg:w-auto"><div class="min-w-0 shrink flex-1"><div class="text-xs uppercase opacity-60">Key</div> <div class="text-lg opacity-70 font-[monospace] font-bold">`;
    if (licenseKeyVisible) {
      $$payload2.out += "<!--[-->";
      $$payload2.out += `<div>${escape_html(data.license?.code)}</div>`;
    } else {
      $$payload2.out += "<!--[!-->";
      $$payload2.out += `<div class="truncate w-full">XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX</div>`;
    }
    $$payload2.out += `<!--]--></div></div> <div class="flex flex-row gap-2 opacity-70">`;
    IconButton($$payload2, {
      class: "material-symbols-outlined",
      onclick: copyLicenseKeyToClipboard,
      children: ($$payload3) => {
        $$payload3.out += `<!---->content_copy`;
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----> `;
    IconButton($$payload2, {
      class: "material-symbols-outlined",
      onclick: toggleLicenseKeyVisibility,
      children: ($$payload3) => {
        if (licenseKeyVisible) {
          $$payload3.out += "<!--[-->";
          $$payload3.out += `visibility_off`;
        } else {
          $$payload3.out += "<!--[!-->";
          $$payload3.out += `visibility`;
        }
        $$payload3.out += `<!--]-->`;
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----></div></div></div></div>`;
  }
  function renderDevices($$payload2) {
    Dialog($$payload2, {
      "aria-labelledby": "event-title",
      "aria-describedby": "event-content",
      onSMUIDialogClosed: deviceAddDialogCloseHandler,
      get open() {
        return deviceAddDialogOpen;
      },
      set open($$value) {
        deviceAddDialogOpen = $$value;
        $$settled = false;
      },
      children: ($$payload3) => {
        Title($$payload3, {
          children: ($$payload4) => {
            $$payload4.out += `<!---->Add device`;
          },
          $$slots: { default: true }
        });
        $$payload3.out += `<!----> `;
        Content($$payload3, {
          children: ($$payload4) => {
            $$payload4.out += `<div class="flex flex-col gap-4">Copy and paste your device ID below. Your device ID is the same as your Support ID. <input${attr("value", newDeviceId)} type="text" name="device-id" class="block w-full p-3 border border-gray-200 rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 text-sm" placeholder="Device ID"></div>`;
          },
          $$slots: { default: true }
        });
        $$payload3.out += `<!----> `;
        Actions($$payload3, {
          children: ($$payload4) => {
            Button($$payload4, {
              action: "cancel",
              color: "secondary",
              children: ($$payload5) => {
                CommonLabel($$payload5, {
                  children: ($$payload6) => {
                    $$payload6.out += `<!---->Cancel`;
                  },
                  $$slots: { default: true }
                });
              },
              $$slots: { default: true }
            });
            $$payload4.out += `<!----> `;
            Button($$payload4, {
              action: "confirm",
              defaultAction: true,
              children: ($$payload5) => {
                CommonLabel($$payload5, {
                  children: ($$payload6) => {
                    $$payload6.out += `<!---->Add`;
                  },
                  $$slots: { default: true }
                });
              },
              $$slots: { default: true }
            });
            $$payload4.out += `<!---->`;
          },
          $$slots: { default: true }
        });
        $$payload3.out += `<!---->`;
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----> <div class="flex justify-between flex-col gap-4 p-6 bg-white border rounded-lg shadow-md"><div class="flex items-center gap-6"><div class="w-10 h-10 rounded-full bg-teal-50 text-teal-600 flex items-center justify-center"><i class="material-symbols-outlined opacity-70">devices</i></div> <div><div class="text-2xl font-display">Your devices</div> <div class="opacity-70">Add or remove devices</div></div> <div class="ml-auto">`;
    IconButton($$payload2, {
      class: "material-symbols-outlined",
      onclick: openAddDeviceDialog,
      children: ($$payload3) => {
        $$payload3.out += `<!---->add`;
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----></div></div> `;
    {
      let chip = function($$payload3, chip2) {
        const deleteDevice = async () => {
          if (devices?.length === 1) {
            message = "You must have at least one device";
            return;
          }
          await fetch(`/api/portal/devices/${chip2}`, { method: "DELETE" });
          goto("/portal", { replaceState: true, invalidateAll: true });
        };
        Chip($$payload3, {
          chip: chip2,
          shouldRemoveOnTrailingIconClick: false,
          class: "truncate max-w-48",
          children: ($$payload4) => {
            Text($$payload4, {
              tabindex: 0,
              children: ($$payload5) => {
                $$payload5.out += `<!---->${escape_html(chip2)}`;
              },
              $$slots: { default: true }
            });
            $$payload4.out += `<!----> `;
            TrailingAction($$payload4, {
              icon$class: "material-symbols-outlined",
              onclick: deleteDevice,
              children: ($$payload5) => {
                $$payload5.out += `<!---->cancel`;
              },
              $$slots: { default: true }
            });
            $$payload4.out += `<!---->`;
          },
          $$slots: { default: true }
        });
      };
      Set_1($$payload2, {
        input: true,
        get chips() {
          return devices;
        },
        set chips($$value) {
          devices = $$value;
          $$settled = false;
        },
        chip,
        $$slots: { chip: true }
      });
    }
    $$payload2.out += `<!----></div>`;
  }
  function renderInstaller($$payload2) {
    $$payload2.out += `<div class="flex justify-between flex-col md:flex-row md:items-center gap-4 p-6 bg-white border rounded-lg shadow-md"><div class="flex items-center gap-6"><div class="w-10 h-10 rounded-full bg-teal-50 text-teal-600 flex items-center justify-center"><i class="material-symbols-outlined opacity-70">download</i></div> <div><div class="text-2xl font-display">Glimmr Installer</div> <div class="opacity-70">With license pre-installed</div></div></div> <div class="flex items-center justify-center gap-4">`;
    if (installer?.status === "error") {
      $$payload2.out += "<!--[-->";
      renderGenerateButton($$payload2);
    } else {
      $$payload2.out += "<!--[!-->";
      Button($$payload2, {
        disabled: installer?.status === "pending",
        color: installer?.status === "completed" ? "secondary" : "primary",
        onclick: generateInstaller,
        class: "gap-2",
        children: ($$payload3) => {
          if (installer?.status === "pending") {
            $$payload3.out += "<!--[-->";
            CircularProgress($$payload3, { class: "w-4 h-4", indeterminate: true });
            $$payload3.out += `<!----> `;
            CommonLabel($$payload3, {
              children: ($$payload4) => {
                $$payload4.out += `<!---->Generating Installer (Step ${escape_html(installer?.progress ?? 1)})`;
              },
              $$slots: { default: true }
            });
            $$payload3.out += `<!---->`;
          } else {
            $$payload3.out += "<!--[!-->";
            if (installer?.status === "completed") {
              $$payload3.out += "<!--[-->";
              CommonIcon($$payload3, {
                class: "material-symbols-outlined",
                children: ($$payload4) => {
                  $$payload4.out += `<!---->refresh`;
                },
                $$slots: { default: true }
              });
              $$payload3.out += `<!----> `;
              CommonLabel($$payload3, {
                children: ($$payload4) => {
                  $$payload4.out += `<!---->Regenerate`;
                },
                $$slots: { default: true }
              });
              $$payload3.out += `<!---->`;
            } else {
              $$payload3.out += "<!--[!-->";
              CommonIcon($$payload3, {
                class: "material-symbols-outlined",
                children: ($$payload4) => {
                  $$payload4.out += `<!---->rocket`;
                },
                $$slots: { default: true }
              });
              $$payload3.out += `<!----> `;
              CommonLabel($$payload3, {
                children: ($$payload4) => {
                  $$payload4.out += `<!---->Generate installer`;
                },
                $$slots: { default: true }
              });
              $$payload3.out += `<!---->`;
            }
            $$payload3.out += `<!--]-->`;
          }
          $$payload3.out += `<!--]-->`;
        },
        $$slots: { default: true }
      });
      $$payload2.out += `<!----> `;
      if (installer?.status === "completed") {
        $$payload2.out += "<!--[-->";
        Button($$payload2, {
          onclick: downloadInstaller,
          children: ($$payload3) => {
            CommonIcon($$payload3, {
              class: "material-symbols-outlined",
              children: ($$payload4) => {
                $$payload4.out += `<!---->download`;
              },
              $$slots: { default: true }
            });
            $$payload3.out += `<!----> `;
            CommonLabel($$payload3, {
              children: ($$payload4) => {
                $$payload4.out += `<!---->Download`;
              },
              $$slots: { default: true }
            });
            $$payload3.out += `<!---->`;
          },
          $$slots: { default: true }
        });
      } else {
        $$payload2.out += "<!--[!-->";
      }
      $$payload2.out += `<!--]-->`;
    }
    $$payload2.out += `<!--]--></div></div>`;
  }
  let $$settled = true;
  let $$inner_payload;
  function $$render_inner($$payload2) {
    Snackbar($$payload2, {
      children: ($$payload3) => {
        CommonLabel($$payload3, {
          children: ($$payload4) => {
            $$payload4.out += `<!---->${escape_html(message)}`;
          },
          $$slots: { default: true }
        });
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----> <div class="container max-w-screen-lg mx-auto p-12 flex flex-col gap-8 z-0">`;
    navbar($$payload2);
    $$payload2.out += `<!----> `;
    license($$payload2);
    $$payload2.out += `<!----> `;
    renderDevices($$payload2);
    $$payload2.out += `<!----> `;
    renderInstaller($$payload2);
    $$payload2.out += `<!----></div>`;
  }
  do {
    $$settled = true;
    $$inner_payload = copy_payload($$payload);
    $$render_inner($$inner_payload);
  } while (!$$settled);
  assign_payload($$payload, $$inner_payload);
  pop();
}
export {
  _page as default
};
